module.exports="#version 300 es\n#define GLSLIFY 1\n\nin vec2 position;\n\nvoid main() {\n\tgl_Position = vec4(position, 0.0, 1.0);\n}\n";